// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderNowMenu_container__HkC_Q","orderNowButton":"OrderNowMenu_orderNowButton__cDqC3"};